import { create } from 'zustand';
import type {
  GridFilterModel,
  GridPaginationModel,
  GridRowSelectionModel,
  GridSortModel,
} from '@mui/x-data-grid';

export interface BaseViewUiState {
  globalSearch: string;
  filterModel: GridFilterModel;
  sortModel: GridSortModel;
  paginationModel: GridPaginationModel;
  rowSelectionModel: GridRowSelectionModel;
  setGlobalSearch: (globalSearch: string) => void;
  setFilterModel: (filterModel: GridFilterModel) => void;
  setSortModel: (sortModel: GridSortModel) => void;
  setPaginationModel: (paginationModel: GridPaginationModel) => void;
  setRowSelectionModel: (rowSelectionModel: GridRowSelectionModel) => void;
  reset: () => void;
}

const initialState = {
  globalSearch: '',
  filterModel: { items: [] } as GridFilterModel,
  sortModel: [] as GridSortModel,
  paginationModel: { page: 0, pageSize: 25 } as GridPaginationModel,
  rowSelectionModel: { type: 'include', ids: new Set() } as GridRowSelectionModel,
};

export const useBaseViewUiStore = create<BaseViewUiState>((set) => ({
  ...initialState,
  setGlobalSearch: (globalSearch) => set({ globalSearch }),
  setFilterModel: (filterModel) => set({ filterModel }),
  setSortModel: (sortModel) => set({ sortModel }),
  setPaginationModel: (paginationModel) => set({ paginationModel }),
  setRowSelectionModel: (rowSelectionModel) => set({ rowSelectionModel }),
  reset: () => set(initialState),
}));
